import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeDeleteKnowledgeBase = (repo: KnowledgeBaseRepository) =>
  (id: string) =>
    repo.delete(id)
